import { UserServicesGetNotifications } from "@services/UserServices";

export default {
    methods: {
        getNotifications(cb1, cb2) {
            if (cb1) cb1(true);

            let allNotifications = [];
            let currentPage = 1;
            const pageSize = 100;

            let filters = {
                pageSize: pageSize,
                currentPage: currentPage,
            };
            UserServicesGetNotifications(filters)
                .then((response) => {
                    let res = response.data;
                    if (res && res.result && res.result.length > 0) {
                        res.result.forEach((e) => {
                            Object.assign(e, {
                                showPreview: false,
                                showOnList: true,
                                seeMoreAboutMessage: false,
                                checkToRemove: false,
                            });
                        });

                        allNotifications = allNotifications.concat(res.result);

                        if (currentPage < res.totalPages) {
                            currentPage += 1;
                        } else {
                            res.result = allNotifications;
                            res.totalRecords = allNotifications.length;
                            res.totalPages = 1;
                            res.currentPage = 1;
                            this.$store.commit("notifications/setNotificationsState", res);
                        }
                    } else {
                        this.$store.commit("notifications/setNotificationsState", {
                            currentPage: 0,
                            pageSize: 0,
                            result: [],
                            totalPages: 0,
                            totalRecords: 0,
                        });
                    }
                })
                .catch((error) => {
                    console.error("Error fetching notifications", error);
                })
                .finally(() => {
                    if (cb1) cb1(false);
                    if (cb2) cb2();
                });
        },
    },
};
